
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

@Component({
    components: {
        FontAwesomeIcon: FontAwesomeIcon,
        'content-partie-auto-child': () => import('./ContentPartieAuto.vue')
    },
    computed: {
        ...mapGetters('exa_formulaire', ['isSelectedInPartieAuto'])
    }
})
export default class ContentPartieAuto extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private reference!: string
    @Prop() private min!: number
    @Prop() private max!: number
    @Prop() private parentMin!: number
    @Prop() private parentMax!: number
    @Prop() private value!: any
    @Prop() private ident!: any
    @Prop() private parentIdent!: any
    @Prop() private content!: any
    @Prop() private partieValue!: any
    @Prop() private isDisabledIf!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() level!: number
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * inputHandler 
     * Gère les événements de saisie de l'input en émettant un événement avec les données appropriées. 
     * @param {any} e - L'événement de saisie. 
     */
    inputHandler(e: any) {
        this.$emit('input', { ident: this.reference, value: this.parentIdent + '_' + e.target.value, checked: e.target.checked, min: this.parentMin, max: this.parentMax })
    }

    /** 
    * cantBeChecked 
    * Vérifie si l'option ne peut pas être cochée en fonction des valeurs de partie actuelles. 
    * @param {None} - Aucun paramètre requis. 
    * @returns {boolean} - True si l'option ne peut pas être cochée, sinon False. 
    */
    cantBeChecked () {
        if (this.partieValue) {
            for (let i = 0; i < this.partieValue.length; i++) {
                for (let j = 0; j < this.partieValue[i].value.length; j++) {
                    if (this.isDisabledIf && this.isDisabledIf.includes(this.partieValue[i].value[j]) && this.partieValue[i].cle  !== this.parentIdent) {
                        return true
                    }
                }
            }
        }
        return false
    }

    /** 
     * inputParentHandler 
     * Gère l'événement d'entrée parent en émettant l'événement 'input' avec les données fournies. 
     * @param {any} e - Les données de l'événement d'entrée parent. 
     */
    inputParentHandler(e: any) {
        this.$emit('input', e)
    }

    /** 
     * shadeColor 
     * Modifie la teinte d'une couleur en fonction de la quantité spécifiée. 
     * @param {string} color - La couleur d'origine au format hexadécimal. 
     * @param {number} amount - La quantité de modification de la teinte. 
     * @returns {string} - La couleur modifiée au format hexadécimal. 
     */
    shadeColor(color: string, amount: number) {
        const retour = '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + (amount * 20))).toString(16)).substr(-2))
        return retour
    }
}
